<!--Table-->
<div class="table-main-body">
	<p-table
		#mydt
		[value]="lstStaff"
		[loading]="loading"
		[paginator]="true"
		[(rows)]="pagerows"
		[(first)]="pagefirst"
		[showCurrentPageReport]="true"
		[resizableColumns]="false"
		sortMode="multiple"
		styleClass="p-datatable-striped"
		selectionMode="single"
		[(selection)]="SelectedStaff"
		dataKey="ID"
		(onFilter)="onHandleFilter($event)"
		(onSort)="onHandleSort($event)"
		(onRowSelect)="onRowSelect($event)"
		(onRowUnselect)="onRowUnselect($event)"
		currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
		[rowsPerPageOptions]="[5, 10, 25, 50]"
	>
		<!--Headers-->
		<ng-template pTemplate="header">
			<!--Filter or Select from Dropdown-->
			<tr>
				<!--INSERT CUSTOM FILTERS HERE-->

				<!--StaffID-->
				<th>
					<p-columnFilter type="text" field="StaffID" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<!--StaffName-->
				<th>
					<p-columnFilter type="text" field="StaffName" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<!--SchoolName-->
				<th>
					<p-columnFilter type="text" field="SchoolName" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<!--ActiveDesc-->
				<th>
					<p-columnFilter field="ActiveDesc" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown
								#filterActiveDesc
								[ngModel]="value"
								[options]="lstActiveDesc"
								(onChange)="filter($event.value)"
								placeholder="Any"
								[showClear]="true"
							>
								<ng-template let-value pTemplate="item">
									<span>{{ value }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th>

				<!--ValidStaffDesc-->
				<th>
					<p-columnFilter field="ValidStaffDesc" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown
								#filterValidStaffDesc
								[ngModel]="value"
								[options]="lstValidStaffDesc"
								(onChange)="filter($event.value)"
								placeholder="Any"
								[showClear]="true"
							>
								<ng-template let-value pTemplate="item">
									<span>{{ value }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th>

				<!--Email-->
				<th>
					<p-columnFilter type="text" field="Email" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<!--PhoneNbr-->
				<th>
					<p-columnFilter type="text" field="Phone" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>
			</tr>

			<!--Column Names-->
			<tr style="height: 4rem">
				<!--INSERT CUSTOM COLUMNS HERE-->
				<th pSortableColumn="StaffID">Staff ID<p-sortIcon field="StaffID"></p-sortIcon></th>
				<th pSortableColumn="StaffName">Name<p-sortIcon field="StaffName"></p-sortIcon></th>
				<th pSortableColumn="SchoolName">School<p-sortIcon field="SchoolName"></p-sortIcon></th>
				<th pSortableColumn="ActiveDesc">Active<p-sortIcon field="ActiveDesc"></p-sortIcon></th>
				<th pSortableColumn="ValidStaffDesc">Valid Staff<p-sortIcon field="ValidStaffDesc"></p-sortIcon></th>
				<th pSortableColumn="Email">Email<p-sortIcon field="Email"></p-sortIcon></th>
				<th pSortableColumn="Phone">Phone<p-sortIcon field="Phone"></p-sortIcon></th>
			</tr>
		</ng-template>

		<!--Data-->
		<ng-template pTemplate="body" let-Staff>
			<tr [pSelectableRow]="Staff">
				<td style="font-weight: bold; text-overflow: ellipsis; word-break: break-word" [style.Color]="Staff.ValidStaff == false ? 'Red' : 'Black'">
					{{ Staff.StaffID }}
				</td>

				<td style="font-weight: bold; text-overflow: ellipsis; word-break: break-word" [style.Color]="Staff.ValidStaff == false ? 'Red' : 'Black'">
					{{ Staff.StaffName }}
				</td>

				<td style="font-weight: bold; text-overflow: ellipsis; word-break: break-word" [style.Color]="Staff.ValidStaff == false ? 'Red' : 'Black'">
					{{ Staff.SchoolName }}
				</td>

				<td
					style="font-weight: bold; text-overflow: ellipsis; word-break: break-word"
					[style.Color]="Staff.ValidStaff == false || Staff.Active == false ? 'Red' : 'Black'"
				>
					{{ Staff.ActiveDesc }}
				</td>

				<td style="font-weight: bold; text-overflow: ellipsis; word-break: break-word" [style.Color]="Staff.ValidStaff == false ? 'Red' : 'Black'">
					{{ Staff.ValidStaffDesc }}
				</td>

				<td style="font-weight: bold; text-overflow: ellipsis; word-break: break-word">
					<input *ngIf="Staff.ValidStaff == true" type="text" class="form-control" [(ngModel)]="Staff.Email" />
					<label *ngIf="Staff.ValidStaff == false" style="color: red">INVALID</label>
				</td>

				<td style="font-weight: bold; text-overflow: ellipsis; word-break: break-word">
					<input *ngIf="Staff.ValidStaff == true" type="text" class="form-control" [(ngModel)]="Staff.Phone" />
					<label *ngIf="Staff.ValidStaff == false" style="color: red">INVALID</label>
				</td>
			</tr>
		</ng-template>
	</p-table>
</div>
